import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-shipment',
  templateUrl: './list-shipment.component.html',
  styleUrls: ['./list-shipment.component.scss']
})
export class ListShipmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
